const vips = {
  namespaced: true,
  state: {
    vips: [],
  },
  getters: {
    getVips: (state) => state.vips,
    vipsCount: (state) => state.vips.length,
    getVipById: (state) => (id) => state.vips.find((vip) => vip.id === id),
  },
  mutations: {
    addvip(state, vip) {
      if (!vip.id) {
        vip.id = Date.now().toString();
      }
      state.vips.push(vip);
    },
    removevip(state, vip) {
      let idx = state.vips.findIndex((f) => f.id === vip.id);
      if (idx >= 0) {
        state.vips.splice(idx, 1);
      }
    },
    editvip(state, vip) {
      let idx = state.vips.findIndex((f) => f.id === vip.id);
      if (idx >= 0) {
        const existingVip = state.vips[idx];
        const updatedVip = { ...existingVip, ...vip };
        state.vips.splice(idx, 1, updatedVip);
      }
    },
  },
};

export default vips;
